'use client';

import { useSyncExternalStore } from 'react';

/**
 * Whether this render is the browser's own, rather than the server's HTML
 * being hydrated.
 *
 * The server cannot know the visitor's clock, timezone or locale, so anything
 * derived from those renders differently in the two places and React tears the
 * whole tree down and re-renders it on the client — reported as a bare
 * `Minified React error #418` naming neither page nor component.
 *
 * Read it as an external store rather than in an effect: React uses the server
 * snapshot for the hydration render, so that render is identical to the HTML
 * by construction, and the correction is scheduled by React itself rather than
 * queued behind a paint.
 *
 * The store never changes, so subscribing is a no-op.
 */
const subscribe = () => () => {};

export function useIsHydrated(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  );
}
